import { render, staticRenderFns } from "./searchNotionScreen.vue?vue&type=template&id=53c0a2a9&scoped=true&"
import script from "./searchNotionScreen.vue?vue&type=script&lang=js&"
export * from "./searchNotionScreen.vue?vue&type=script&lang=js&"
import style0 from "./searchNotionScreen.vue?vue&type=style&index=0&id=53c0a2a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0a2a9",
  null
  
)

export default component.exports